import BaseModel from './BaseModel'

export default class Board extends BaseModel {}

Board.mapping = {}
